import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, Row, ModalFooter, Button, Spinner, Input } from "reactstrap";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import { FormattedNumber } from "../../FormattedNumber/FormattedNumber";
import { Field, Combobox } from "../Order/Field/Field";
import { ProductType, getBaseAndPriceCurrencies } from "../../../utils";
import { SymbolField, ProductField } from "./FormFields";
import classnames from "classnames";
import style from "./Trading.module.scss";
import Column from "./Column";

class Trading extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      loadingEarnings: false,
      form: ProductType.BOND,
      asset: {
        id: null,
        name: null,
        error: null,
      },
      settleCurrency: {
        id: null,
        name: null,
        error: null,
      },
      settlementCurrencies: [],
      buy: [{ id: 1, route: null, date: new Date().toDatetimeLocal() }],
      sell: [{ id: 2, route: null, date: new Date().toDatetimeLocal() }],
      totals: {
        buyQuantity: 0,
        buyAverage: 0,
        sellQuantity: 0,
        sellAverage: 0,
        earnings: {
          buy: 0,
          sell: 0,
        },
      },
      tradeRoutes: [],
    };
  }

  componentDidUpdate(prevProps, prevState) {
    const { form, asset, settleCurrency } = this.state;
    const { form: prevForm, asset: prevAsset } = prevState;

    const { services } = this.props;
    const { fetchTradingRoutesForAsset, fetchOrderAssetInfo } = services;

    if (form != prevForm) {
      this.setState({
        asset: {
          id: null,
          name: null,
          error: null,
        },
        settleCurrency: {
          id: null,
          name: null,
          error: null,
        },
        settlementCurrencies: [],
        tradeRoutes: [],
      });
    } else if (asset.id != prevAsset.id) {
      if (asset.id) {
        if (form != "Forex") {
          this.setState({
            tradeRoutes: null,
          });
          fetchTradingRoutesForAsset({ assetId: asset.id, quantity: 0 }) //Le paso 0 para que use la cantidad total
            .then((res) => {
              this.setState({
                tradeRoutes: res.response.sorroutes.map((r) => ({
                  id: r.id,
                  description: r.name,
                })),
              });
            });
        }

        fetchOrderAssetInfo({
          tradeDate: new Date(),
          orderForm: form,
          assetId: asset ? asset.id : 0,
          assetTicker: "",
          tradeCurrencyId: asset ? asset.id : 0, // Cuando es FX, asset.id tiene la moneda de trade.
          settleCurrencyId: settleCurrency ? settleCurrency.id : 0,
        }).then((res) => {
          const data = res.response.assetorderdata;
          const currency = data.items.find((i) => i.key == "Currency");
          const settlementCurrencies = data.settlementCurrency.map((c) => ({
            id: c.currencyInfo.currencyId,
            description: c.currencyInfo.currencyISO,
            multiplies: c.multiplies,
            fx: c.fx,
          }));
          const settlementCurrency = {
            id: null,
            name: null,
            error: null,
          };
          if (settlementCurrencies && settlementCurrencies.length > 0) {
            settlementCurrency.id = settlementCurrencies[0].id;
            settlementCurrency.name = settlementCurrencies[0].description;
          }

          this.setState((state) => ({
            asset: {
              ...state.asset,
              currency: currency.value,
            },
            settlementCurrencies,
            settleCurrency: settlementCurrency,
          }));
        });
      } else {
        this.setState({
          settleCurrency: {
            id: null,
            name: null,
            error: null,
          },
          settlementCurrencies: [],
          tradeRoutes: [],
        });
      }
    }
  }

  newRow = (side) => {
    const newId = Math.random().toString(36).substr(2, 4);

    this.setState({
      [side]: [...this.state[side], { id: newId, route: null, date: new Date().toDatetimeLocal() }],
    });
  };

  delRow = (side, id) => {
    this.setState(
      {
        [side]: [...this.state[side].filter((r) => r.id !== id)],
      },
      () => this.calcTotals()
    );
  };

  onChangeRow = (side, id, entries) => {
    const otherProps = {};

    if (side == "buy" && entries.hasOwnProperty("quantity") && !isNaN(entries.quantity)) {
      const index = this.state.buy.findIndex((e) => e.id == id);

      if (this.state.sell.length > index) {
        otherProps.sell = [...this.state.sell];

        otherProps.sell[index] = {
          ...this.state.sell[index],
          quantity: entries.quantity,
        };
      }
    }

    this.setState(
      {
        [side]: [
          ...this.state[side].map((item, i) => {
            if (item.id !== id) {
              return item;
            }

            const errors = item.errors
              ? Object.keys(entries).reduce((obj, e) => {
                  obj[e] = undefined;
                  return obj;
                }, {})
              : {};

            return {
              ...item,
              ...entries,
              errors: {
                ...item.errors,
                ...errors,
              },
            };
          }),
        ],
        ...otherProps,
      },
      () => this.calcTotals()
    );
  };

  onChange = (name, { values, value }) => {
    if (value) {
      let _value = value;
      if (name == "settleCurrency") {
        const { settlementCurrencies } = this.state;

        _value = {
          id: _value,
          name: settlementCurrencies.find((c) => c.id == _value).description,
        };
      }

      this.setState({
        [name]: _value,
      });
    } else {
      this.setState({
        [name]: { ...values },
      });
    }
  };

  validate = () => {
    const { asset, settleCurrency } = this.state;
    const needFX = asset.currency != settleCurrency.name && asset.id != null;

    const sidesState = {
      buy: [...this.state.buy],
      sell: [...this.state.sell],
    };

    const assetState = { ...asset };
    const settleCurrencyState = { ...settleCurrency };

    let hasErrors = false;

    Object.keys(sidesState).forEach((side) => {
      this.state[side].forEach((e, i) => {
        let errors = {};

        if (e.counterpartyId === undefined || e.counterpartyId === null) {
          errors.counterpartyId = "Required field";
        }

        if (e.quantity === undefined || e.quantity === "" || e.quantity === 0) {
          errors.quantity = "Required field";
        }

        if (e.price === undefined || e.price === "" || e.price === 0) {
          errors.price = "Required field";
        }

        if (e.route === undefined || e.route == null) {
          errors.route = "Required field";
        }

        if (needFX) {
          if (e.fx === undefined || e.fx === "" || e.fx === 0) {
            errors.fx = "Required field";
          }
        }

        hasErrors |= Object.values(errors).length > 0;
        sidesState[side][i].errors = errors;
      });
    });

    if (asset.id === undefined || asset.id === null || asset.id === "") {
      assetState.error = "Required field";
      hasErrors = true;
    }

    if (settleCurrency.id === undefined || settleCurrency.id === null || settleCurrency.id === "") {
      settleCurrencyState.error = "Required field";
      hasErrors = true;
    }

    this.setState({
      buy: sidesState.buy,
      sell: sidesState.sell,
      asset: assetState,
      settleCurrency: settleCurrencyState,
    });

    return !hasErrors;
  };

  execute = () => {
    if (this.validate()) {
      this.setState({ loading: true });
      const { form, asset, settleCurrency, buy, sell, settlementCurrencies } = this.state;
      const { services } = this.props;
      const { fetchAddTradingExecutions } = services;

      let fxMultiplies = true;

      const settleCurrencyInfo = settlementCurrencies.find((c) => c.id == settleCurrency.id);
      if (settleCurrencyInfo) {
        fxMultiplies = settleCurrencyInfo.multiplies;
      }

      const tradingExecutions = [
        ...buy.map((b) => ({
          Side: "Buy",
          Quantity: +b.quantity,
          Price: +b.price,
          FX: b.fx,
          FXMultiplies: fxMultiplies,
          CounterPartyId: b.counterpartyId,
          CounterPartyName: b.counterpartyName,
          TradingRouteId: b.route,
          DateTime: b.date,
          source: source,
        })),

        ...sell.map((b) => ({
          Side: "Sell",
          Quantity: b.quantity,
          Price: b.price,
          FX: b.fx,
          FXMultiplies: fxMultiplies,
          CounterPartyId: b.counterpartyId,
          CounterPartyName: b.counterpartyName,
          TradingRouteId: b.route,
          DateTime: b.date,
          source: b.source,
        })),
      ];

      fetchAddTradingExecutions({
        form,
        tradingExecutions,
        settlementCurrency: settleCurrency.name,
        assetTicker: asset.name,
      }).then((r) => {
        this.props.toggle();
      });
    }
  };

  calcTotals = () => {
    let totals = {
      buyQuantity: 0,
      buyAverage: 0,
      sellQuantity: 0,
      sellAverage: 0,
      earnings: {
        buy: 0,
        sell: 0,
      },
    };

    ["buy", "sell"].forEach((side) => {
      let sumQuantity = 0;
      let sumAvgPrice = 0;

      this.state[side].forEach((row) => {
        if (row.counterpartyId && !isNaN(row.quantity) && !isNaN(row.price)) {
          sumQuantity += +row.quantity;
          sumAvgPrice += +row.quantity * +row.price;
        }
      });

      totals[`${side}Quantity`] = sumQuantity;
      totals[`${side}Average`] = sumQuantity ? sumAvgPrice / sumQuantity : 0;
    });

    this.setState({ totals }, () => {
      const { asset, totals } = this.state;
      const { services } = this.props;
      const { fetchTradingEarnings } = services;

      const { buyQuantity, sellQuantity, buyAverage, sellAverage } = totals;
      if (
        asset.id !== undefined &&
        asset.id !== null &&
        asset.id !== "" &&
        buyQuantity > 0 &&
        sellQuantity > 0 &&
        buyAverage > 0 &&
        sellAverage > 0
      ) {
        this.setState({ loadingEarnings: true });
        Promise.all([
          // buy earnings
          fetchTradingEarnings({
            assetid: asset.id,
            quantity: buyQuantity,
            pricedif: buyAverage,
          }).then(({ earnings }) => earnings),
          // sell earnings
          fetchTradingEarnings({
            assetid: asset.id,
            quantity: buyQuantity,
            pricedif: sellAverage,
          }).then(({ earnings }) => earnings),
        ]).then(([buyEarnings, sellEarnings]) => {
          // all results
          this.setState({
            loadingEarnings: false,
            totals: {
              ...totals,
              earnings: { buy: +buyEarnings, sell: +sellEarnings },
            },
          });
        });
      } else {
        this.setState({
          totals: { ...totals, earnings: { buy: null, sell: null } },
        });
      }
    });
  };

  render() {
    const { open, toggle, counterparties, services } = this.props;
    const {
      form,
      buy,
      sell,
      totals,
      asset,
      settleCurrency,
      settlementCurrencies,
      route,
      loading,
      tradeRoutes,
      loadingEarnings,
    } = this.state;

    const needFX = asset.currency != settleCurrency.name && asset.id != null;

    const isFX = form == "Forex";

    const { baseCurrency, priceCurrency } = getBaseAndPriceCurrencies(
      settlementCurrencies,
      asset.currency,
      settleCurrency.name
    );

    const FXPair = `${baseCurrency}/${priceCurrency}`;

    return (
      <Modal isOpen={open} toggle={toggle} className={style.modal} style={modalStyle(needFX)}>
        <ModalHeader toggle={toggle}>Trading</ModalHeader>
        <ModalBody style={{ padding: "5px 15px", minHeight: "225px" }}>
          <div className={style.headerForm}>
            <ProductField form={form} onChange={this.onChange} disabled={loading} />

            {!isFX && (
              <SymbolField
                label={"Asset"}
                error={asset.error}
                form={form}
                disabled={loading}
                value={asset}
                onChange={({ id, name }) => this.onChange("asset", { values: { id, name } })}
                services={services}
              />
            )}

            {/* ##### Trade Currency ###### */}
            {isFX ? (
              <div className={style.symbol}>
                <SymbolField
                  label={"Trade Currency"}
                  error={asset.error}
                  form={form}
                  value={asset}
                  onChange={({ id, name }) => this.onChange("asset", { values: { id, name } })}
                  services={services}
                />
              </div>
            ) : (
              <Field label={"Trade Currency"} error={asset.error}>
                <Input type="text" placeholder="Trade Currency" value={asset.currency || ""} disabled />
              </Field>
            )}

            {/* ##### Settlement Currency ###### */}
            <Field label={"Settl. Currency"} error={settleCurrency.error}>
              <Combobox
                value={settleCurrency.id}
                items={settlementCurrencies}
                disabled={loading}
                onChange={(v) => this.onChange("settleCurrency", { value: v })}
                emptyLabel={"Settl. Currency"}
              />
            </Field>
          </div>
          <Row>
            <div className={style.columnContainer}>
              <Column
                side="buy"
                needFX={needFX}
                FXPair={FXPair}
                rows={buy}
                loading={loading}
                newRow={this.newRow}
                delRow={this.delRow}
                onChange={this.onChangeRow}
                counterparties={counterparties}
                tradeRoutes={tradeRoutes}
              />
              <Column
                side="sell"
                needFX={needFX}
                FXPair={FXPair}
                rows={sell}
                loading={loading}
                newRow={this.newRow}
                delRow={this.delRow}
                onChange={this.onChangeRow}
                counterparties={counterparties}
                tradeRoutes={tradeRoutes}
              />
            </div>
          </Row>
        </ModalBody>

        <ModalFooter className={style.footer}>
          <div className={style.content}>
            <SideDetail side="buy" quantity={totals.buyQuantity} average={totals.buyAverage} />
            <SideDetail side="sell" quantity={totals.sellQuantity} average={totals.sellAverage} />
            <OversDetail totals={totals} loadingEarnings={loadingEarnings} />
          </div>

          <div className={style.actions}>
            {!loading && (
              <Button color="light" onClick={toggle}>
                Close
              </Button>
            )}{" "}
            <LaddaButton
              className={classnames("btn btn-ladda btn-primary ml-1", style.buy)}
              loading={loading}
              onClick={() => this.execute()}
              data-style={EXPAND_RIGHT}
            >
              Execute
            </LaddaButton>
          </div>
        </ModalFooter>
      </Modal>
    );
  }
}

const modalStyle = (needFX) => ({
  maxWidth: needFX ? "1010px" : "780px",
});

const OversDetail = ({ totals, loadingEarnings }) => (
  <BoxDetail>
    <table>
      <tbody>
        <tr>
          <td className={style.buy}>Buy side</td>
          <td>
            {loadingEarnings ? (
              <Spinner size="sm" className="ml-2" />
            ) : (
              <Number value={totals.earnings.buy} dataTypeDecimalName="currency" />
            )}
          </td>
        </tr>
        <tr>
          <td className={style.sell}>Sell side</td>
          <td>
            {loadingEarnings ? (
              <Spinner size="sm" className="ml-2" />
            ) : (
              <Number value={totals.earnings.sell} dataTypeDecimalName="currency" />
            )}
          </td>
        </tr>
        <tr>
          <td>Earnings</td>
          <td>
            {loadingEarnings ? (
              <Spinner size="sm" className="ml-2" />
            ) : (
              <Number value={totals.earnings.sell - totals.earnings.buy} dataTypeDecimalName="currency" />
            )}
          </td>
        </tr>
      </tbody>
    </table>
  </BoxDetail>
);

const SideDetail = ({ side, quantity, average }) => (
  <BoxDetail>
    <table>
      <tbody>
        <tr>
          <td className={style[side]}>{side.capitalize()} side quantity</td>
          <td>
            <Number value={quantity} dataTypeDecimalName="quantity" />
          </td>
        </tr>
        <tr>
          <td>Average price</td>
          <td>
            <Number value={average} dataTypeDecimalName="price" />
          </td>
        </tr>
      </tbody>
    </table>
  </BoxDetail>
);

const BoxDetail = ({ children }) => (
  <div className={style.box}>
    <div className={style.container}>{children}</div>
  </div>
);

export const Number = ({ value, decimalScale, dataTypeDecimalName }) => (
  <span className={style.number}>
    {value === null ? (
      "-"
    ) : (
      <FormattedNumber value={value} decimalScale={decimalScale} dataTypeDecimalName={dataTypeDecimalName} />
    )}
  </span>
);

export default Trading;

//
